module.exports = __webpack_public_path__ + "static/media/aboutus.42d01067.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/aboutus.svg
// module id = 136
// module chunks = 0